module.exports = __webpack_public_path__ + "img/Spearman64_ua.0d3a0d9c.webp";